export default __webpack_public_path__ + "static/media/NESTLE.e447bf1f.png";